module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showHeader('h1')) ? _c('h1', [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
    class: _vm.getIcon()
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._label) + "\n  ")]) : (_vm.showHeader('h2')) ? _c('h2', [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
    class: _vm.getIcon()
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._label) + "\n  ")]) : (_vm.showHeader('h3')) ? _c('h3', [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
    class: _vm.getIcon()
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._label) + "\n  ")]) : (_vm.showHeader('h4')) ? _c('h4', [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
    class: _vm.getIcon()
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._label) + "\n  ")]) : (_vm.showHeader('h5')) ? _c('h5', [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
    class: _vm.getIcon()
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._label) + "\n  ")]) : (_vm.showHeader('h6')) ? _c('h6', [(_vm.attr.icon !== '' && _vm.attr.icon !== undefined) ? _c('i', {
    class: _vm.getIcon()
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm._label) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-245d856c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderLabel.vue
// module id = 899
// module chunks = 2